import SideBar from './SideBar';
import { Outlet } from 'react-router-dom';
import TradeNavBar from './TradeNavBar';
import { getToken } from '../utils';
import Modal from './Modal';
import PersonaVerification from '../Verification/Persona';
import { useState } from 'react';

function TradeLayout() {
  const [showNav, setShowNav] = useState(false);

  const persona = getToken()?.user.persona;
  return (
    <div className=''>
      <div className=' flex overflow-hidden h-screen isolate'>
        <div
          className={`flex-[30%] lg:block lg:flex-[20%] h-screen bg-p-wh top-0 absolute lg:relative w-full sm:w-2/5 lg:w-full drop-shadow-lg pt-[80px] z-10 ${
            showNav ? 'block' : 'hidden'
          }`}
        >
          <SideBar setShowNav={setShowNav} />
        </div>
        <div className='col-span-3 pt-[60px] m- overflow-y-auto flex-[70%] lg:flex-[80%]'>
          {persona ? (
            <Outlet />
          ) : (
            <Modal open={!persona}>
              <PersonaVerification />
            </Modal>
          )}
        </div>
      </div>
      <div className=' w-full top-0 fixed drop-shadow'>
        <TradeNavBar setShowNav={setShowNav} />
      </div>
    </div>
  );
}

export default TradeLayout;
